import { SHOW_NAV_MODAL, HIDE_NAV_MODAL } from './actions';

const initialState = {
  navigationModalIsVisible: false,
  navigationModalData: {
    text: [],
    link: '',
    target: '',
  },
  navigationIsExternal: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NAV_MODAL:
      return {
        ...state,
        navigationModalIsVisible: true,
        navigationModalData: action.payload,
        navigationIsExternal: action.isExternal,
      };
    case HIDE_NAV_MODAL:
      return {
        ...state,
        navigationModalIsVisible: false,
      };
    default:
      return state;
  }
};
